module.exports = __webpack_public_path__ + "static/media/attendance.6e9e8d5b.svg";